/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Widget_Render_ErrorInputs */



/**
* | output |
* | --- |
* | "This element could not be displayed." |
*
* @param {Chat_Widget_Render_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_widget_render_error = /** @type {((inputs?: Chat_Widget_Render_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Widget_Render_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Element konnte nicht angezeigt werden.")
	return /** @type {LocalizedString} */ ("This element could not be displayed.")
});